import React, { useState, Dispatch, SetStateAction } from "react";
import { useQueryClient } from "react-query";
import { useRequiredMsgs } from "../../store/requiredMsgs";
import { useStore } from "../../store/store";
import { useAccordion } from "../../store/accordion";
import api from "../../api/api";
import { postCustomGlass } from "../../api/SidebarApi";
import "../RemoveEditDuplicate/EditBtn.css";
import { UnitObj } from "../../util/quoteCartStorage";

function useUnitActionsSelector(
  quoteId: string,
  unit: UnitObj,
  setEditQuote: Dispatch<SetStateAction<boolean>>,
  setWindowOrDoor: Dispatch<SetStateAction<string>>
) {
  const queryClient = useQueryClient();

  const isEdit = useStore((state) => state.isEdit);

  const setRequired = useRequiredMsgs((state) => state.setRequired);

  const setExpandedFromEdit = useAccordion(
    (state) => state.setExpandedFromEdit
  );

  const setStoreFromEdit = useStore((state) => state.setStoreFromEdit);

  const [switchChecked, setSwitchChecked] = useState(
    unit?.customGlass || false
  );

  const [open, setOpen] = useState(false);
  const [openKD, setOpenKD] = useState(false);

  const [loading, setLoading] = useState(false);

  const [modalType, setModalType] = useState("");

  const [error, setError] = useState(false);

  const handleCheck = (e: React.ChangeEvent<HTMLInputElement>) =>
    setSwitchChecked(e.target.checked);

  const handleOpen = (type: string) => {
    setModalType(type);
    setOpen(true);
  };

  const handleClose = () => {
    setModalType("");
    setOpen(false);
  };

  const handleOpenKD = () => setOpenKD(true);

  const handleCloseKD = () => setOpenKD(false);

  const getUnit = () => {
    sessionStorage.setItem("unitId", JSON.stringify(unit._id));
    setLoading(true);
    api
      .get("/api/history/getUnit", {
        params: { quoteId, unitId: unit._id },
      })
      .then((res) => {
        if (unit.doorType.includes("Bi-fold")) {
          setWindowOrDoor(unit.doorType.replace("f", "F"))
        }

        const local = JSON.parse(res.data.localStorageState);
        const localKeys = Object.keys(local);

        const unitInfo = res.data.unitInfo;

        //backwards compatibility
        if (unitInfo.addScreen && !unitInfo.screenType) {
          unitInfo["screenType"] = "Brio Accordion Screen";
        }

        setStoreFromEdit(unitInfo);

        for (var key of localKeys) {
          if (key === "quoteCart") continue;

          if (key !== "accordionControl" && key !== "store") {
            localStorage.setItem(key, local[key]);
          }
        }

        setExpandedFromEdit();

        setEditQuote((prevEdit) => !prevEdit);
        // console.log("Required: ", res.data.required)
        setRequired(res.data.required);
      })
      .then((data) => {
        setLoading(false);
        setError(false);
        handleClose();
      })
      .catch((err) => {
        console.log(err);
        setError(true);
      });
  };

  const addCustomGlass = async () => {
    const res = await postCustomGlass(quoteId, unit._id || "", switchChecked);

    if (res.data.error) {
      return setError(true);
    }

    handleClose();
    setError(false);
    return queryClient.invalidateQueries("QuoteCart");
  };

  const InEditState = () => alert("Please Finish Editing Current Unit.");

  return {
    InEditState,
    addCustomGlass,
    getUnit,
    handleOpenKD,
    handleCloseKD,
    handleOpen,
    handleCheck,
    error,
    modalType,
    loading,
    open,
    openKD,
    isEdit,
    handleClose,
    switchChecked
  };
}

export default useUnitActionsSelector;
